import { render, staticRenderFns } from "./P0195.vue?vue&type=template&id=31f259c3&scoped=true&"
import script from "./P0195.vue?vue&type=script&lang=ts&"
export * from "./P0195.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f259c3",
  null
  
)

export default component.exports